import { render } from "./Reception.vue?vue&type=template&id=15c1f90d&scoped=true"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"

import "./Reception.vue?vue&type=style&index=0&id=15c1f90d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15c1f90d"

export default script